module.exports = __webpack_public_path__ + "static/media/SalmaAliandaScript-Regular.33e924b9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SalmaAliandaScript-Regular.ttf
// module id = 2418
// module chunks = 43